
import { BuildingContent } from "../../components/building"

export default function Building() {

  return (
    <>
      <BuildingContent/>
    </>
  )

}